<template>
    <div class="filter-sidebar" :class="{ open: filterOpen }" @click.stop>
        <div class="filter-sidebar-inner">
            <div class="title-line">
                <span>Filter</span>
                <div @click="closeFilter" class="close-button"></div>
            </div>
            <div class="horizontal-line"></div>
            <div class="checkboxes">
                <div
                    v-for="category in globalJson.blogCategories"
                    :key="category.slug"
                    :class="['checkbox-item', { active: isChecked(category) }]"
                    @click="handleFilterClick(category)"
                >
          <span class="box">
              <CheckBox class="cb"/>
          </span>
                    <span class="lbl">{{ category.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CheckBox from "@/components/svgs/CheckBox.vue";
export default {
    name: "FilterSidebar",
    components: {
        CheckBox,
    },
    data() {
        return {
            globalJson: {}
        };
    },
    computed: {
        ...mapState({
            filterOpen: state => state.filterOpen,
            selectedFilters: state => state.selectedFilters
        })
    },
    mounted() {
        // Assuming the global JSON config is available on window.config.json.global
        this.globalJson = window.config.json.global;
        // Listen for escape key globally
        document.addEventListener("keydown", this.handleEscape);
    },
    beforeUnmount() {
        document.removeEventListener("keydown", this.handleEscape);
    },
    watch: {
        $route() {
            // Automatically close the filter on route changes
            this.closeFilter();
        },
        filterOpen(newVal) {
            if (newVal) {
                // Use nextTick to ensure the sidebar has fully opened before adding the listener
                this.$nextTick(() => {
                    document.addEventListener("click", this.handleClickOutside);
                });
            } else {
                document.removeEventListener("click", this.handleClickOutside);
            }
        }
    },
    methods: {
        closeFilter() {
            this.$store.commit("closeFilter");
        },
        handleFilterClick(category) {
            this.$store.commit("filterClick", category);
        },
        isChecked(category) {
            return this.selectedFilters.some(filter => filter.slug === category.slug);
        },
        handleEscape(event) {
            if (event.key === "Escape" && this.filterOpen) {
                this.closeFilter();
            }
        },
    }
};
</script>
